module.exports = __webpack_public_path__ + "static/media/image_9.f178061e.png";